import { HlmLabel } from './lib/hlm-label';

export * from './lib/hlm-label';

export const HlmLabelImports = [HlmLabel] as const;
